import React from 'react';
import './UniverseError.css';

const UniverseError = ({
  onRetry,
  message = 'The universe is recalculating',
  showDots = true,
  showEquation = true,
  buttonText = 'Try Again',
  onDismiss
}) => {
  return (
    <div className="universe-error">
      {/* Twinkling stars background */}
      <div className="stars-container">
        {[...Array(50)].map((_, i) => (
          <div
            key={i}
            className="star"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 2}s`,
            }}
          />
        ))}
      </div>

      {/* Main content */}
      <div className="universe-error-content">
        {/* Einstein's Field Equation SVG - optional */}
        {showEquation && (
          <svg
            className="einstein-equation"
            viewBox="0 0 290 80"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#f8f8f8" />
                <stop offset="50%" stopColor="#ffd700" />
                <stop offset="100%" stopColor="#f8f8f8" />
              </linearGradient>
            </defs>

            {/* G with subscript μν */}
            <text x="10" y="50" className="equation-text" fill="url(#goldGradient)">
              G
            </text>
            <text x="38" y="58" className="equation-subscript" fill="url(#goldGradient)">
              μν
            </text>

            {/* Equals sign */}
            <text x="80" y="50" className="equation-text" fill="url(#goldGradient)">
              =
            </text>

            {/* 8πG */}
            <text x="120" y="50" className="equation-text" fill="url(#goldGradient)">
              8πG
            </text>

            {/* T with subscript μν */}
            <text x="210" y="50" className="equation-text" fill="url(#goldGradient)">
              T
            </text>
            <text x="238" y="58" className="equation-subscript" fill="url(#goldGradient)">
              μν
            </text>
          </svg>
        )}

        {/* Rate limit icon - shown when equation is hidden */}
        {!showEquation && (
          <div className="rate-limit-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="url(#goldGradientIcon)" strokeWidth="1.5"/>
              <path d="M12 7V12L15 15" stroke="url(#goldGradientIcon)" strokeWidth="1.5" strokeLinecap="round"/>
              <defs>
                <linearGradient id="goldGradientIcon" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#f8f8f8" />
                  <stop offset="50%" stopColor="#ffd700" />
                  <stop offset="100%" stopColor="#f8f8f8" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        )}

        {/* Message */}
        <p className="universe-message">{message}</p>

        {/* Animated dots - optional */}
        {showDots && (
          <div className="loading-dots">
            <span className="dot">.</span>
            <span className="dot">.</span>
            <span className="dot">.</span>
          </div>
        )}

        {/* Action buttons */}
        <div className="universe-buttons">
          {onRetry && (
            <button className="retry-button" onClick={onRetry}>
              {buttonText}
            </button>
          )}
          {onDismiss && (
            <button className="retry-button dismiss-button" onClick={onDismiss}>
              Dismiss
            </button>
          )}
        </div>
      </div>

      {/* Subtle orbital ring */}
      <div className="orbital-ring" />
    </div>
  );
};

export default UniverseError;
